import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";

export const Container = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { outerField } = tokens;

    return css`
      border-radius: ${outerField.radius};

      &:has([data-focused]) {
        outline-width: ${outerField.focusRing.width.focus};
        outline-style: ${outerField.focusRing.style};
        outline-color: ${outerField.focusRing.color};
        outline-offset: ${outerField.focusRing.offset.focus};
      }
    `;
  }}
`;

export const InnerContainer = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { outerField } = tokens;

    return css`
      display: grid;
      grid-template-columns: 1fr;
      grid-auto-flow: column;
      gap: ${outerField.gap};
      min-height: ${outerField.minHeight};
      border-radius: ${outerField.radius};
      outline-width: ${outerField.stroke.width.base};
      outline-style: ${outerField.stroke.style};
      outline-color: ${outerField.stroke.color.base};
      outline-offset: ${outerField.stroke.offset.base};
      background: ${outerField.backgroundColor};

      &:has([data-invalid]) {
        outline-width: ${outerField.stroke.width.error};
        outline-color: ${outerField.stroke.color.error};
        outline-offset: ${outerField.stroke.offset.error};
      }

      &:has([data-hovered]) {
        outline-width: ${outerField.stroke.width.hover};
        outline-color: ${outerField.stroke.color.hover};
        outline-offset: ${outerField.stroke.offset.hover};
      }

      &:has([data-focused]) {
        outline-width: ${outerField.stroke.width.focus};
        outline-color: ${outerField.stroke.color.focus};
        outline-offset: ${outerField.stroke.offset.focus};
      }

      &:has([data-disabled]) {
        outline-width: ${outerField.stroke.width.base};
        outline-color: ${outerField.stroke.color.disabled};
        outline-offset: ${outerField.stroke.offset.base};
      }
    `;
  }}
`;
